import React from 'react';

export const FileIcon = ({ className }) => (
  <svg width="24" height="30" viewBox="0 0 24 30" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M13.375 1H3.75039C3.02107 1 2.32162 1.295 1.80592 1.8201C1.29021 2.3452 1.00049 3.05739 1.00049 3.8V26.2C1.00049 26.9426 1.29021 27.6548 1.80592 28.1799C2.32162 28.705 3.02107 29 3.75039 29H20.2498C20.9791 29 21.6786 28.705 22.1943 28.1799C22.71 27.6548 22.9997 26.9426 22.9997 26.2V10.8L13.375 1Z" fill="white" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13.3745 1V10.8H22.9992" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
